import { objectEntries } from '@/utils/typedObjectHelpers';
import clsx from 'clsx';
import React from 'react';

export type TabConfig = {
  label: string;
  content: React.ReactNode;
  isHidden: boolean;
  icon?: React.ReactNode;
};

interface SlideOverTabsProps<T extends string> {
  tabs: Record<T, TabConfig>;
  activeTab: T | null;
  setActiveTab: React.Dispatch<React.SetStateAction<T | null>>;
}

export const SlideOverTabs = <T extends string>(props: SlideOverTabsProps<T>) => {
  return (
    <div className="flex flex-1 flex-col">
      <div className="flex gap-7">
        {objectEntries(props.tabs)
          .filter(([_, value]) => !value.isHidden)
          .map(([key, value]) => (
            <button
              className={clsx(
                'relative flex gap-2 py-2 text-sm',
                key === props.activeTab ? 'text-blue-700' : 'text-gray-500',
              )}
              aria-label={`${value.label}-tab`}
              onClick={() => props.setActiveTab(key)}
              key={key}
            >
              {value.label} {value.icon}
              {key === props.activeTab && (
                <span className="absolute bottom-[-1px] left-0 right-0 h-px bg-blue-700" /> // Active tab unline overlaps with the <hr />
              )}
            </button>
          ))}
      </div>
      <hr className="pb-3" />
      {props.activeTab && (
        <div className="flex flex-1 flex-col">{props.tabs[props.activeTab].content}</div>
      )}
    </div>
  );
};
